import React from "react";
import styles from "./Logo.module.scss";
import THEME from "../../../state/theme";
import Header from '../../../assets/header.png';

export default ({ dark, url }) => (
  <figure
    className={[styles.logo, dark ? styles.dark : styles.light].join(" ")}
    style={{ border: "none" }}
  >
    {/* <i className="las la-fire" /> */}
    <img style={{ maxWidth: "10em" }} src={url} />
    {/* <span>
      Ruminate
    </span> */}
  </figure>
);
